import '@/assets/app.scss'
import 'vue3-toastify/dist/index.css'

import { createUi } from '@atabix/vue-ui'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import Vue3Toastify, { toast, type ToastContainerOptions } from 'vue3-toastify'

import { handleGlobalError } from '@/helpers/GlobalErrorHandler'
import { watchServiceWorkerUpdates } from '@/helpers/ServiceWorkerUpdates'
import { i18n, useI18n } from '@/plugins/i18n'
import { useAppStore } from '@/stores/app'

import App from './App.vue'
import router from './router'

const app = createApp(App)

const pinia = createPinia()
const ui = createUi()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.config.errorHandler = handleGlobalError
app.use(Vue3Toastify, {
  autoClose: 5000,
} as ToastContainerOptions)

app.use(router)
app.use(ui)
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: { staleTime: 30_000, refetchOnWindowFocus: false },
    },
  },
})
useI18n(app, i18n, 'nl')

app.mount('#app')

const appStore = useAppStore()
watchServiceWorkerUpdates({
  container: 'serviceWorker' in navigator ? navigator.serviceWorker : undefined,
  isAppReady: (): boolean => appStore.isReady,
  onUpdateAvailable: (): void => {
    toast.info(i18n.global.t('updateAvailable'), { autoClose: false, closeOnClick: true, onClick: (): void => globalThis.location.reload() })
  },
  reload: (): void => globalThis.location.reload(),
})

export function getApp() {
  return app
}
